import React from 'react';
import { FiSearch, FiX } from 'react-icons/fi';

/**
 * Always-visible list search control used across Jobs / Candidates / Users.
 */
export default function ListSearchBar({
  id = 'list-search',
  value,
  onChange,
  onClear,
  placeholder = 'Search…',
  label = 'Search',
  showClear = true,
}) {
  const hasValue = Boolean(String(value || '').trim());

  return (
    <div className="list-search-bar">
      <label className="visually-hidden" htmlFor={id}>
        {label}
      </label>
      <div className="list-filter-input-icon list-search-bar__input">
        <FiSearch aria-hidden />
        <input
          id={id}
          type="search"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete="off"
        />
        {showClear && hasValue && (
          <button
            type="button"
            className="list-search-bar__clear"
            aria-label="Clear search"
            onClick={() => (onClear ? onClear() : onChange(''))}
          >
            <FiX aria-hidden />
          </button>
        )}
      </div>
    </div>
  );
}
